import { BehaviorSubject } from 'rxjs';

export class UIModel {
  static mockId: number = -1;
  static mockName: string = '이름';
  static mockNumber: number = 1;
  static mockBool: boolean = false;
  static mockDate: Date = new Date();
  static mockString: string = '문자열';
  static mockImage: string = 'https://picsum.photos/200/300';
  static mockVideo: string =
    'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4';

  static make<T extends UIModel>(count: number, factory: () => T): T[] {
    const output: T[] = [];
    for (let i = 0; i < count; i++) {
      const item = factory();
      item.mock(i);
      output.push(item);
    }
    return output;
  }

  id: number;
  constructor() {
    this.id = Math.round(Math.random() * 1000000000);
  }

  init() {
    return this;
  }

  mock(index?: number) {}

  toJSON() {
    const output: any = {};
    Object.keys(this).forEach((key) => {
      if ((this as any)[key] === undefined) {
        output[key] = undefined;
      } else if ((this as any)[key] === null) {
        output[key] = null;
      } else if (Array.isArray((this as any)[key])) {
        output[key] = (this as any)[key].map((item: any) => {
          if (item.toJSON) {
            return item.toJSON();
          } else {
            return item;
          }
        });
      } else if ((this as any)[key] instanceof BehaviorSubject) {
        output[key] = (this as any)[key].value;
      } else if ((this as any)[key].toJSON) {
        output[key] = (this as any)[key].toJSON();
      } else {
        output[key] = (this as any)[key];
      }
    });
    return output;
  }
}
